export const translations = {
  ko: {
    // 헤더
    appName: "AivyStudio",
    json: "JSON",
    preview: "미리보기",
    save: "저장",
    deploy: "배포",

    // 탭
    create: "생성",
    edit: "편집",

    // 설문 생성 탭
    surveyTitle: "설문 제목",
    surveyTitlePlaceholder: "예: 직무 만족도 조사",
    surveyPurpose: "설문 목적 및 설명",
    surveyPurposePlaceholder: "어떤 목적의 설문인지 설명해주세요",
    surveyImage: "설문지 이미지 (선택)",
    collectPersonalInfo: "개인정보 수집",
    collectPersonalInfoDesc: "이름, 생년월일, 연락처 등을 수집합니다",
    requiredElements: "필수 포함 요소 (선택)",
    requiredElementsPlaceholder: "꼭 포함되어야 할 질문이나 내용",
    generateSurvey: "AI로 설문 생성하기",
    generateSurveyWithAI: "AI로 설문을 생성해보세요",
    aiGenerating: "AI가 생성 중...",

    // 개인정보 필드
    name: "이름",
    birthdate: "생년월일",
    phone: "휴대폰번호",
    gender: "성별",
    email: "이메일",
    addCustomField: "기타 필드 추가",
    fieldNamePlaceholder: "필드명 입력",
    customFieldTooltip: "직업, 설문 경로 등을 추가하세요",

    // 테스트 실행 탭
    testRun: "테스트 실행하기",
    selectQuestionToEdit: "질문을 선택하세요",
    enterSurveyInfo: "왼쪽 패널에서 설문 정보를 입력하고\n버튼을 클릭하면 AI가 자동으로 생성합니다",

    // 질문 편집기
    question: "질문",
    questionEdit: "질문 편집",
    placeholder: "플레이스홀더",
    placeholderExample: "예: 답변을 입력하세요",
    options: "선택지 목록",
    addOption: "선택지 추가",
    required: "필수 질문으로 설정",
    deleteQuestion: "질문 삭제",

    // 질문 유형
    questionTypes: {
      text: "주관식",
      select: "객관식", 
      multiselect: "다중선택",
      image: "이미지"
    },

    // 공통
    required_marker: "필수",
    selectOption: "선택하세요",
    submit: "제출하기",
    close: "닫기",
    copy: "복사",
    copied: "복사됨",
    newOption: "새 옵션",

    // 인증
    accessRestricted: "접근 제한",
    expertAccountRequired: "전문가 등록 계정만 사용할 수 있는 페이지입니다.",
    login: "로그인하기",

    // 배포 모달
    deployComplete: "배포 완료!",
    deployMessage: "설문지가 성공적으로 배포되었습니다.",
    deployUrl: "배포 URL",

    // 테스트 모달
    testComplete: "테스트 완료!",
    testMessage: "설문 응답이 성공적으로 제출되었습니다.",
    submittedResponses: "제출된 응답",
    confirm: "확인",
    retryTest: "다시 테스트",
    restartTest: "테스트 다시하기",
    next: "다음",
    previous: "이전",

    // 미리보기
    personalInfo: "개인정보",

    // 이미지 업로드
    clickToUpload: "클릭하여 이미지 업로드",
    imageFormats: "PNG, JPG, JPEG (최대 10MB)",
    remove: "삭제",
    imagePreviewText: "이미지 업로드 필드",
    uploadedImage: "업로드된 이미지",

    // 메시지 및 알림
    pleaseEnterSurveyInfo: "설문 정보를 입력해주세요.",
    pleaseCompleteRequiredFields: "필수 항목을 모두 작성해주세요.",
    saveInProgress: "저장 기능은 개발 중입니다.",
    testing: "테스트 중...",
    aiAnalysisResult: "AI 분석 결과",
    testCompleteDesc: "설문 응답이 성공적으로 제출되었습니다.",
    editQuestionInfo: "왼쪽 목록에서 편집할 질문을 클릭해주세요",
    select: "선택하세요",
    test: "테스트 실행하기",
  },
  en: {
    // 헤더
    appName: "AivyStudio",
    json: "JSON", 
    preview: "Preview",
    save: "Save",
    deploy: "Deploy",

    // 탭
    create: "Create",
    edit: "Edit",

    // 설문 생성 탭
    surveyTitle: "Survey Title",
    surveyTitlePlaceholder: "e.g., Job Satisfaction Survey",
    surveyPurpose: "Survey Purpose & Description",
    surveyPurposePlaceholder: "Describe the purpose of this survey",
    surveyImage: "Survey Image (Optional)",
    collectPersonalInfo: "Collect Personal Information",
    collectPersonalInfoDesc: "Collect personal information like name, birthdate, contact, etc.",
    requiredElements: "Required Elements (Optional)",
    requiredElementsPlaceholder: "Questions or content that must be included",
    generateSurvey: "Generate Survey with AI",
    generateSurveyWithAI: "Generate a survey with AI",
    aiGenerating: "AI is generating...",

    // 개인정보 필드
    name: "Name",
    birthdate: "Date of Birth",
    phone: "Phone Number",
    gender: "Gender",
    email: "Email",
    addCustomField: "Add Custom Field",
    fieldNamePlaceholder: "Enter field name",
    customFieldTooltip: "Add occupation, survey source, etc.",

    // 테스트 실행 탭
    testRun: "Run Test",
    selectQuestionToEdit: "Select a Question",
    enterSurveyInfo: "Enter survey information in the left panel\nand click the button to automatically generate with AI",

    // 질문 편집기
    question: "Question",
    questionEdit: "Edit Question",
    placeholder: "Placeholder",
    placeholderExample: "e.g., Enter your answer",
    options: "Option List",
    addOption: "Add Option",
    required: "Required",
    deleteQuestion: "Delete Question",

    // 질문 유형
    questionTypes: {
      text: "Text Input",
      select: "Single Choice",
      multiselect: "Multiple Choice",
      image: "Image"
    },

    // 공통
    required_marker: "Required",
    selectOption: "Please select",
    submit: "Submit",
    close: "Close",
    copy: "Copy",
    copied: "Copied",
    newOption: "New Option",

    // 인증
    accessRestricted: "Access Restricted",
    expertAccountRequired: "This page is only available to expert registered accounts.",
    login: "Login",

    // 배포 모달
    deployComplete: "Deployment Complete!",
    deployMessage: "The survey has been successfully deployed.",
    deployUrl: "Deployment URL",

    // 테스트 모달
    testComplete: "Test Complete!",
    testMessage: "Survey response has been successfully submitted.",
    submittedResponses: "Submitted Responses",
    confirm: "Confirm",
    retryTest: "Test Again",
    restartTest: "Restart Test",
    next: "Next",
    previous: "Previous",

    // 미리보기
    personalInfo: "Personal Information",

    // 이미지 업로드
    clickToUpload: "Click to upload image",
    imageFormats: "PNG, JPG, JPEG (max 10MB)",
    remove: "Remove",
    imagePreviewText: "Image Upload Field",
    uploadedImage: "Uploaded Image",

    // 메시지 및 알림
    pleaseEnterSurveyInfo: "Please enter survey information.",
    pleaseCompleteRequiredFields: "Please complete all required fields.",
    saveInProgress: "Save feature is under development.",
    testing: "Testing...",
    aiAnalysisResult: "AI Analysis Result",
    testCompleteDesc: "Survey response has been successfully submitted.",
    editQuestionInfo: "Click a question from the left list to edit",
    select: "Please select",
    test: "Run Test",
  }
};